import React, { useEffect, useState } from "react";
import "./App.css";
import { authProtectedRoutes, publicRoutes } from "./Routes/allRoutes";
import { Route, Routes, useNavigate } from "react-router-dom";
import VerticalLayout from "./Layouts/VerticalLayout";
import HorizotanlLayout from "./Layouts/HorizontalLayout/index";
import "./assets/scss/theme.scss";
import NonAuthLayout from "./Layouts/NonLayout";

//constants
import {
  LAYOUT_TYPES,
} from "./components/constants/layout";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import AuthProtected from "Routes/AuthProtected";
import { FilterDataId } from "features/reducers/filterdata/FilterData.Reducers";
import { useTypedDispatch } from "features/reduxhooks/ReduxHooks";
import { LocalNotifications } from "@capacitor/local-notifications";
import { Capacitor } from "@capacitor/core";
import { setFilterToAll_v1 } from "features/reducers/filterdata/DashboardFilter.Reducers";
import PersonalDetailsServices from "services/PersonalDetails.Services";
import { logoutUser } from "slices/thunk";
import CommonService from "services/CommonService";
import { getDecodedAccessToken } from "../src/helpers/TokenHelper";
import { getLocalStorage } from "../src/helpers/Helper";

// Activating fake backend
fakeBackend();

const getLayout = (layoutType: any) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case LAYOUT_TYPES.VERTICAL:
      Layout = VerticalLayout;
      break;
    case LAYOUT_TYPES.HORIZONTAL:
      Layout = HorizotanlLayout;
      break;
    default:
      break;
  }
  return Layout;
};

function App() {
  let navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const [userMenuList, setUserMenuList] = useState([]);

  const tileKeys = [{
    tileKey: 1,
    tileName: "All",
  },
  {
    tileKey: 2,
    tileName: "Open",
  },
  {
    tileKey: 3,
    tileName: "In-Progress",
  },
  {
    tileKey: 4,
    tileName: "Completed",
  },
  {
    tileKey: 5,
    tileName: "Failed",
  },
  {
    tileKey: 6,
    tileName: "Cancel Request",
  },
  {
    tileKey: 7,
    tileName: "Cancelled",
  },
  {
    tileKey: 8,
    tileName: "Pending",
  },
  {
    tileKey: 9,
    tileName: "Return",
  }];

  const selectLeadData = createSelector(
    (state: any) => state.Layout,
    (layoutTypes) => layoutTypes
  );
  const { layoutTypes } = useSelector(selectLeadData);
  const Layout = getLayout(layoutTypes);

  // CapacitorApp.addListener('backButton', ({ canGoBack }) => {
  //   if (!canGoBack) {
  //     CapacitorApp.exitApp();
  //   } else {
  //     window.history.back();
  //   }
  // });

  useEffect(() => {
    let today = new Date();
    let priorDate = new Date(new Date().setDate(today.getDate() - 90));

    dispatch(FilterDataId({ payload: priorDate, type: "FromDate" }));
    dispatch(FilterDataId({ payload: null, type: "ToDate" }));

    tileKeys.forEach(x => {
      dispatch(setFilterToAll_v1(x.tileKey));
    })

  }, [dispatch]);


  const registerNotifications = async () => {
    await LocalNotifications.checkPermissions().then(res => {
      if (res.display == "prompt") {
        LocalNotifications.requestPermissions().then(async result => {
          if (result.display != "granted") {
            await LocalNotifications.requestPermissions();
          }
        })
      }
    });
  };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      registerNotifications();
    }
  }, []);


  const isActiveUser = () => {
    PersonalDetailsServices.IsActiveUser().then(res => {
      if (res.status == 200) {
        if (res.data == false) {
          navigate('/logout');
        }
      }
    }).catch(e => {
      console.log(e);
      navigate('/logout');
    });
  }

  useEffect(() => {
    let authToken = localStorage.getItem("authUser") as string
    if (authToken) { 
      // isActiveUser();
     }
  }, []);


  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} key={idx}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>} />
        ))}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <React.Fragment>
                <AuthProtected>
                  <Layout>{route.component}</Layout>
                </AuthProtected>
              </React.Fragment>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  );
}

export default App;
